/*!
 * Copyright (c) 2023. Bluemate B.V.
 */

@use '../../../../style/common-variables' as commons;

.product-costs-popup {
  width: min(100dvw, 78rem);

  .product-costs-list {
    display: grid;
    grid-row-gap: 1.5rem;

    .list-tabs {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);

      .list-tab {
        border-bottom: 2px solid commons.$color-gray-4;
        cursor: pointer;
        transition: border-color 0.2s ease-in-out;
        display: flex;
        justify-content: center;

        .tab-label {
          color: commons.$color-gray-3;
          font-weight: 600;
          transition: color 0.2s ease-in-out;
          padding-bottom: 0.5rem;
          display: block;
          user-select: none;
        }

        &:hover {
          .tab-label {
            color: black;
          }
        }

        &.active {
          border-color: commons.$color-blue-bluemate;

          .tab-label {
            color: commons.$color-blue-bluemate;
          }
        }
      }
    }

    .add-btn {
      justify-self: start;
    }

    .product-costs-table {
      position: relative;

      .row {
        grid-template-columns: 8rem 8rem 10rem 5rem 10rem 8rem 10rem 10rem fit-content(100%);

        .product-costs-actions {
          display: grid;
          grid-template-columns: repeat(2, fit-content(100%));
          grid-column-gap: 0.5rem;

          .action {
            cursor: pointer;
            transition: color 0.2s ease-in-out;
            font-size: 0.9rem;

            &:hover {
              color: commons.$color-blue-bluemate;

              &.delete {
                color: red;
              }
            }
          }
        }
      }
    }
  }

  .selected-costs {
    display: grid;
    grid-row-gap: 1.5rem;

    .row {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 2rem;
    }

    .costs-container {
      display: grid;
      grid-row-gap: 1.5rem;
      padding: 1.5rem 0;
      border-top: 1px solid commons.$color-gray-4;
      border-bottom: 1px solid commons.$color-gray-4;
    }

    .misc-costs-container {
      border-bottom: 1px solid commons.$color-gray-4;
      padding-bottom: 1.5rem;

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }

      .misc-costs {
        display: grid;
        grid-row-gap: 1.5rem;
        max-height: 15rem;
        overflow-y: auto;
        margin: 0.5rem 0;

        .misc-cost {
          display: grid;
          grid-template-columns: repeat(2, 1fr) 1rem;
          grid-column-gap: 2rem;
          align-items: center;

          .delete-btn {
            cursor: pointer;
            font-size: 0.9rem;
            transition: color 0.2s ease-in-out;

            &:hover {
              color: red;
            }
          }
        }
      }
    }
  }
}
